import { Component, OnDestroy, OnInit, inject, signal } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { ChipModule } from 'primeng/chip';
import { ProfileService } from '../services/profile.service';
import { User } from '../../shared/models/user.model';
import { LocalstorageService } from '../../shared/services/localstorage.service';
import { UserFormComponent } from "../../user/user-form/user-form.component";
import { CardModule } from 'primeng/card';
import { AccessService } from '../../core/services/access.service';
import { UserService } from '../../user/services/user.service';

@Component({
  selector: 'app-profile-description',
  standalone: true,
  imports: [ChipModule, ButtonModule, UserFormComponent, CardModule],
  templateUrl: './profile-description.component.html',
  styleUrl: './profile-description.component.css'
})
export class ProfileDescriptionComponent implements OnInit {

  protected profileService = inject(ProfileService)
  protected accessService = inject(AccessService)
  private userService = inject(UserService)
  private ls = inject(LocalstorageService)

  ngOnInit(): void {
    this.userService.title.update((value) => 'detalles del perfil');
    this.profileService.validateProfile()
  }

  getToken(): string {
    const token = this.ls.get('token', { decrypt: true })
    console.log('Token: ', token)
    return token || '';
  }
}
